// import 'react-app-polyfill/ie9';
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import ReactDOM                                            from "react-dom";
//import { Router, Route, Switch, Redirect }                 from "react-router-dom";
  import { Router, Switch, Redirect, BrowserRouter }         from "react-router-dom";
  import { Provider }                                        from "react-redux";
  import { store, history }                                  from "./_helpers";
//import { PrivateRoute, RefreshRoute }                      from "components/PrivateRoute";
  import { PrivateRoute }                                    from "components/PrivateRoute";

  import AdminLayout                                         from "layouts/Admin.jsx";
//import AuthLayout                                          from "layouts/Auth.jsx";

  import { api }                                             from "./_constants";

//import "./i18n"; //trans
  //----------
  // Libraries
  //----------
  import TagManager_old                                      from 'react-gtm-module'
  import TagManager                                          from 'react-gtm-module'

  import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
  //import "./assets/css/fontawesome.min.css";
  //
  const tagManagerArgs_old = { gtmId:api.tagManagerKey_old };
  TagManager_old.initialize(tagManagerArgs_old);

  const tagManagerArgs = { gtmId:api.tagManagerKey };
  TagManager.initialize(tagManagerArgs);

  // console.log("bbbbbbbbbbbbbbbbbb");
  // if (!global._babelPolyfill) {
  //   console.log("aaaaaaaaaaaa");
  // 	require('babel-polyfill');
  // }
  global._babelPolyfill = false;

  ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
        <Router history={history}>
          <Switch>
            <Redirect     from="/"                   exact to={api.webapp_path+"/auth"} />
            <Redirect     from={api.webapp_path+"/"} exact to={api.webapp_path+"/auth"} />
          {/*<Route        path="/auth"              component={AuthLayout} /> */}
            <PrivateRoute path={api.webapp_path}     component={AdminLayout} />
          </Switch>
        </Router>
        </BrowserRouter>
    </Provider>,document.getElementById("root")
  );
